(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      document.addEventListener('page:loaded', () => this.initQuickShop());

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true });
      }

      if (!Shopify.designMode) return;

      this.addEventListener('shopify:block:select', (event) => {
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      });
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var self = this;
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      var preloaded = false;

      // Capture-phase interceptor registered before modal binds its handler.
      // On mobile, blocks the modal handler so the link navigates normally.
      links.forEach(link => {
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);
      });

      function preload() {
        if (preloaded) return;
        preloaded = true;
        var sectionEl = self.closest('[id^="shopify-section-"]');

        links.forEach(link => {
          var handle = link.dataset.productHandle;
          var productId = link.dataset.productId;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);
        });
      }

      if (!theme.config.bpSmall) preload();

      new ResizeObserver(() => {
        if (!theme.config.bpSmall) preload();
      }).observe(document.documentElement);
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
